import { Injectable } from '@angular/core';

import { CertificateResolverActions, AppleDeviceApiActions } from './certificate.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppleDevicesService } from '@rocksoft/mdm-sdk-v2';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';

@Injectable()
export class CertificateEffects {
  constructor(
    private readonly actions: Actions,
    private readonly appleDevicesService: AppleDevicesService
  ) {}

  certificateRequestedEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(CertificateResolverActions.certificatesRequested),
      mergeMap(({ udid }) =>
        safeMap(
          this.appleDevicesService.getCertificates(udid, '2.0'),
          (certificates) =>
            AppleDeviceApiActions.certificatesLoaded({
              certificates: certificates.map((certificate) => ({
                ...certificate,
                udid: udid,
              })),
            }),
          (error) => AppleDeviceApiActions.certificatesLoadedError({ error })
        )
      )
    );
  });
}
